import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { action, computed, observable } from 'mobx';
import { HistoryFilter } from 'services/pangolin/types';
import { createLocationFilterOptions } from 'ui/history/location_entry/location_entry_logic';
import { CountryCode } from 'services/base/countries';
import { notUndefined } from 'ui/base/types';

export class LocationInputStore {
  search: SearchInputStore;

  @observable.shallow entries: CountryCode[];
  @observable.shallow options: readonly CountryCode[];

  constructor(filter: HistoryFilter) {
    this.search = new SearchInputStore();

    const entries = filter.locations;

    this.entries = entries;
    this.options = createLocationFilterOptions(entries);
  }

  @action.bound
  commitEntry(entry: CountryCode): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: CountryCode): void {
    const index = this.entries.findIndex(e => e === entry);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @computed
  get countryCodes(): CountryCode[] {
    return this.entries.filter(notUndefined);
  }
}
